// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItens_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /config/menu_itens/delete
 *
 * Deletes a menu item by ID.
 */
import { registerContract } from './validate'

export interface MenuItens_DeleteInput {
id: number
}

registerContract('MenuItens_DeleteInput', {
  id: { type: 'number',  required: true },
})
